import React from 'react'
import { Col, Flex, Row, Table } from 'antd'
import { StarFilled } from '@ant-design/icons';
import ZCard from '../../Card/Index'
import { intraBankTransfer } from '../../../utils/JsonData/Interbank transfers 1'
import CustomAmountText from '../../common/CustomAmountText';
import { CURRENCY } from '../../../utils/ConstantData';


const IntraBankTransfersPage = () => {
  return (
    <IntraFundTransferTables circularData={intraBankTransfer} />
  )
}

const IntraFundTransferTables = ({ circularData }) => {
    const { circular } = circularData;
  
    const intraBankFundTransfer = circular[0].intraBankFundTransfer;
    const fisrtIdPair = circular[0]?.idPair[0];
    const secondIdPair = circular[0]?.idPair[1];
    
    const yesbin02202Data = intraBankFundTransfer.filter((item) => item.bankAccountId === fisrtIdPair);
    const yesbin03563Data = intraBankFundTransfer.filter((item) => item.bankAccountId === secondIdPair);

    const calculateTotal = (data) => {
        const totalDebit = data.reduce((sum, item) => (item.type === 'DB' ? sum + item.amount : sum),0);
        const totalCredit = data.reduce((sum, item) => (item.type === 'CR' ? sum + item.amount : sum),0);
    
        return { totalDebit, totalCredit };
    };

    const yesbin02202Totals = calculateTotal(yesbin02202Data);
    const yesbin03563Totals = calculateTotal(yesbin03563Data);

    const columns = [
      {
        title: 'Txn Date',
        dataIndex: 'date',
        key: 'date',
        width: 180
      },
      {
        title: 'Particulars',
        dataIndex: 'particulars',
        key: 'particulars',
        width: 190
      },
      {
        title: `Debit (${CURRENCY})`,
        dataIndex: 'debit',
        key: 'debit',
        align: 'right',
        className: 'no-wrap-column',
        render: (text, record) => (record.type === 'DB' ? <CustomAmountText value={record.amount} /> : ''),
      },
      {
        title: `Credit (${CURRENCY})`,
        dataIndex: 'credit',
        key: 'credit',
        align: 'right',
        className: 'no-wrap-column',
        render: (text, record) => (record.type === 'CR' ? <CustomAmountText value={record.amount} /> : ''),
      },
    ];
  
    return (
        <Row gutter={[16, 16]} style={{ marginBottom: 10 }}>
            <Col xs={24} sm={24} md={12}>
                <ZCard>
                    <Flex className='pl-16 ' justify='space-between'>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <StarFilled style={{ color: '#1890ff', marginRight: 8, marginTop: -11, fontSize: '20px' }} />
                            <ZCard.Title>{`${circular[0].accountPair[0] === undefined ? 'No data' : circular[0].accountPair[0]}`}</ZCard.Title>
                        </div>
                    </Flex>
                    <Table
                        columns={columns}
                        dataSource={yesbin02202Data}
                        rowKey={(record) => `${record.bankAccountId}-${record.date}-${record.amount}`}
                        pagination={{ pageSize: 5 }}
                        summary={() => (
                            <Table.Summary.Row>
                            <Table.Summary.Cell />
                            <Table.Summary.Cell>Total</Table.Summary.Cell>
                            <Table.Summary.Cell>{<CustomAmountText value={yesbin02202Totals.totalDebit.toFixed(2)} />}</Table.Summary.Cell>
                            <Table.Summary.Cell>{<CustomAmountText value={yesbin02202Totals.totalCredit.toFixed(2)} />}</Table.Summary.Cell>
                            </Table.Summary.Row>
                        )}
                    />
                </ZCard>
            </Col>
            <Col xs={24} sm={24} md={12}>
                <ZCard>
                    <Flex className='pl-16 ' justify='space-between'>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <StarFilled style={{ color: '#1890ff', marginRight: 8, marginTop: -11, fontSize: '20px' }} />
                            <ZCard.Title>{`${circular[0].accountPair[1] === undefined ? 'No data' : circular[0].accountPair[1]}`}</ZCard.Title>
                        </div>
                    </Flex>
                    <Table
                        columns={columns}
                        dataSource={yesbin03563Data}
                        rowKey={(record) => `${record.bankAccountId}-${record.date}-${record.amount}`}
                        pagination={{ pageSize: 5 }}
                        summary={() => (
                            <Table.Summary.Row>
                            <Table.Summary.Cell />
                            <Table.Summary.Cell>Total</Table.Summary.Cell>
                            <Table.Summary.Cell>{ <CustomAmountText value={yesbin03563Totals.totalDebit.toFixed(2)} />}</Table.Summary.Cell>
                            <Table.Summary.Cell>{<CustomAmountText value={yesbin03563Totals.totalCredit.toFixed(2)} />}</Table.Summary.Cell>
                            </Table.Summary.Row>
                        )}
                    />
                </ZCard>
            </Col>
        </Row>
    );
};

export default IntraBankTransfersPage